<template>
  <div class="metting">
    <!-- 手机端内容 -->
    <div class="mobile_metting_page">
      <img width="100%" src="../assets/img/mobile/metting.jpg" alt="" />

      <div class="mobile_video">
        <video
          src="http://lambor.oss-cn-shenzhen.aliyuncs.com/meetingVedio.mp4"
          controls="controls"
          autoplay
          loop
          width="100%"
        ></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'metting',
  data () {
    return {}
  },
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1170px) {
  .mobile_metting_page {
    display: block;
  }
}
.mobile_video {
  position: absolute;
  top: 26%;
  padding: 40px;
  video {
    border: 4px solid #0357d3;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/metting.vue